import _ from 'lodash'
import fieldType from '@/enums/fieldType'
import Cookies from 'js-cookie'
import FIELD_GROUP from '@/enums/print/fieldGroup'
import FormAdapter from '@/plugins/FormAdapter'
import Vue from 'vue'
import i18n from '@/plugins/vuei18n'

function getFieldById(state, id, group = FIELD_GROUP.DYNAMIC) {
  let collection
  switch (group) {
    case FIELD_GROUP.DYNAMIC:
      collection = state.schemaBuilder.fields
      break
    case FIELD_GROUP.CONSTANT:
      collection = state.schemaBuilder.print.constant_fields
      break
    case FIELD_GROUP.GENERATED:
      collection = state.schemaBuilder.print.generated_fields
      break
    default:
      return null
  }
  return _.find(collection, {
    id
  })
}

function getSubFieldById(state, id) {
  return _.find(_.find(state.schemaBuilder.fields, {
    'sub-fields': [{
      id
    }]
  })['sub-fields'], {
    id
  })
}

function assignDefaultFieldOptions(fields) {
  fields.forEach(field => {
    var defaultOptions
    switch (field.type) {
      case fieldType.DATE:
        defaultOptions = {
          required: false
        }
        break
      case fieldType.NUMBER:
        defaultOptions = {
          required: false,
          min: null,
          max: null
        }
        break
      case fieldType.RADIO:
        defaultOptions = {
          required: false
        }
        break
      case fieldType.TEXT:
        defaultOptions = {
          required: false,
          minLength: null,
          maxLength: null
        }
        break
      case fieldType.TIME:
        defaultOptions = {
          required: false
        }
        break
      case fieldType.TABLE:
        assignDefaultFieldOptions(field['sub-fields'])
        defaultOptions = {}
        break
      default:
        defaultOptions = {}
    }
    if (field.options === 'undefined' || field.options === null || field.options === '') {
      field.options = defaultOptions
    } else {
      _.assign(defaultOptions, field.options)
    }
  })
}

function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

function newFieldIds(fields, table_id = null) {
  fields.forEach(field => {
    let oldId =field.id
    field.id = uuid()
    field.old_id = oldId
    fixFieldIdInOptions(fields, oldId,field.id)
    if (table_id) {
      field.field_id = table_id
    }
    if (field.type === fieldType.TABLE) {
      newFieldIds(field['sub-fields'], field.id)
    }
  })
}

function fixFieldIdInOptions(fields, oldId, newId){
  fields.forEach(field => {
    let fieldsStr = JSON.stringify(field.options)
    fieldsStr = fieldsStr.replaceAll(oldId, newId)
    field.options = JSON.parse(fieldsStr)

    if (field.type === fieldType.TABLE) {
      fixFieldIdInOptions(field['sub-fields'], oldId, newId)
    }
  })
}

export default {
  authRequest: state => {
    state.authStatus = 'loading'
  },
  authSuccess: (state, payload) => {
    state.authStatus = 'success'
    state.token = payload.token
    state.tokenExpiration = payload.tokenExpiration
    state.refreshToken = payload.refreshToken || ''
  },
  authError: state => {
    state.authStatus = 'error'
  },
  authLogout: state => {
    state.authStatus = 'logout'
    state.token = ''
    state.tokenExpiration = null
    state.refreshToken = ''
  },
  authRefresh: state => {
    state.authStatus = 'refresh'
  },
  setTeams(state, payload) {
    state.teams = payload
  },
  setUsers(state, payload) {
    state.users = payload
  },
  updateTeam(state, payload) {
    let team = _.find(state.teams, {
      id: payload.id
    })
    _.assign(team, payload)
  },
  setFieldTypes(state, payload) {
    state.fieldTypes = payload
  },
  appendTeam(state, payload) {
    state.teams.push(payload)
  },
  appendArchiveFilter(state, filter) {
    state.archiveFilters.push(filter)
  },
  deleteArchiveFilter(state, id) {
    state.archiveFilters = state.archiveFilters.filter(filter => filter.id != id)
  },
  updateArchiveFilter(state, payload) {
    state.archiveFilters = state.archiveFilters.filter(el => el.id != payload.id)
    state.archiveFilters.push(payload)
    state.archiveFilters.sort((a, b) => a.id - b.id)
  },
  removeTeam(state, index) {
    state.teams.splice(index, 1)
  },
  setSchemaBuilder(state, payload) {
    assignDefaultFieldOptions(payload.fields)
    newFieldIds(payload.fields)
    // newFieldIds(payload.print.constant_fields)
    state.schemaBuilder = payload
  },
  updateSchemaBuilderProperty(state, payload) {
    state.schemaBuilder[payload.type] = payload.value
  },
  updateSchemaBuilderPrintProperty(state, payload) {
    state.schemaBuilder.print[payload.prop] = payload.value
  },
  addConstant(state, payload) {
    state.schemaBuilder.print.constant_fields.push(payload)
  },
  addGenerated(state, payload) {
    state.schemaBuilder.print.generated_fields.push(payload)
  },
  flushSchemaBuilder(state) {
    state.schemaBuilder = {
      name: '',
      type : 1,
      document_type_id : null,
      status: 1,
      teams: [],
      fields: [],
      print: {
        title: '',
        format: 'A4',
        font: 'Open Sans',
        orientation: 'v',
        margin_left: 30,
        margin_right: 30,
        margin_top: 20,
        margin_bottom: 20,
        constant_fields: [],
        generated_fields: []
      },
      confirmation: 0
    }
  },
  updateField(state, payload) {
    let field = getFieldById(state, payload.id)
    _.assign(field, payload)
  },
  updateSubField(state, payload) {
    let subField = getSubFieldById(state, payload.id)
    _.assign(subField, payload)
  },
  setFieldValues(state, payload) {
    let field = getFieldById(state, payload.id)
    field.values = payload.values
  },
  setSubFieldValues(state, payload) {
    let subField = getSubFieldById(state, payload.id)
    subField.values = payload.values
  },
  updateFieldOptions(state, payload) {
    let field = getFieldById(state, payload.id)
    _.assign(field.options, payload.options)
  },
  updateSubFieldOptions(state, payload) {
    let subField = getSubFieldById(state, payload.id)
    if(subField.options == null || subField.options == undefined){
        subField.options = {}
    }
    _.assign(subField.options, payload.options)
  },
  updateFieldDescription(state, payload) {
    let field = getFieldById(state, payload.id)
    field.description = payload.description
  },
  updateSubFieldDescription(state, payload) {
    let subField = getSubFieldById(state, payload.id)
    subField.description = payload.description
  },
  updateFields(state, payload) {
    state.schemaBuilder.fields = payload
  },
  updateSubFields(state, payload) {
    let field = getFieldById(state, payload.field_id)
    field['sub-fields'] = payload.subFields
  },
  updateFieldLocation(state, payload) {
    let field = getFieldById(state, payload.id, payload.group)
    _.assign(field.location, payload.location)
  },
  flushFieldLocation(state, id) {
    let field = getFieldById(state, id)
    field.location = null
  },
  flushFieldsLocations(state) {
    state.schemaBuilder.fields.forEach(field => {
      field.location = null
    })
    state.schemaBuilder.print.constant_fields = []
  },
  removePrintField(state, payload) {
    let collection = (payload.group === FIELD_GROUP.CONSTANT) ? state.schemaBuilder.print.constant_fields : state.schemaBuilder.print.generated_fields
    let index = _.findIndex(collection, {
      id: payload.id
    })
    collection.splice(index, 1)
  },
  appendField(state, payload) {
    state.schemaBuilder.fields.push(payload)
  },
  appendFieldAfterIndex(state, payload) {
    let inputAfter = payload.inputAfter
    delete payload.inputAfter
    state.schemaBuilder.fields.splice(inputAfter,0,payload)
  },
  appendSubField(state, payload) {
    let field = getFieldById(state, payload.field_id)
    payload['type_id'] = _.find(state.fieldTypes, {
      name: payload.type
    }).id
    field['sub-fields'].push(payload)
  },
  removeField(state, index) {
    state.schemaBuilder.fields.splice(index, 1)
  },
  removeSubField(state, payload) {
    let field = getFieldById(state, payload.field_id)
    field['sub-fields'].splice(payload.index, 1)
  },
  setSchemaFieldOrders(state) {
    for (var key in state.schemaBuilder.fields) {
      let field = state.schemaBuilder.fields[key]
      field.order = parseInt(key) + 1
      if (field.type === fieldType.TABLE) {
        for (var subKey in field['sub-fields']) {
          let subField = field['sub-fields'][subKey]
          subField.order = parseInt(subKey) + 1
        }
      }
    }
  },
  setSnack(state, snack) {
    state.snack = snack
  },
  switchDarkTheme(state) {
    if (typeof state.darkTheme === 'string') {
      state.darkTheme = state.darkTheme === 'true'
    }
    state.darkTheme = !state.darkTheme
    Cookies.set('darkTheme', state.darkTheme)
  },
  changeDefaultTableRowsAmount(state, amount) {
    state.pagination.rowsPerPage = amount
    Cookies.set('defaultRowsPerPage', amount)
  },
  changeLanguage(state, lang){
    state.lang = lang
    Vue.set(i18n, 'locale', lang)
    Cookies.set('lang', lang)
  },
  setUpForms(state, payload) {
    state.forms = {
      schema: payload.schema,
      amount: payload.count,
      results: payload.forms,
    }
  },
  setArchiveFilters(state, payload) {
    state.archiveFilters = payload
  },
  confirmRecord(state, payload) {
    var record = state.forms.results.find(rec => rec.id === payload.id)
    if (record) {
      Vue.set(record, "confirmed_at", payload.confirmed_at)
      Vue.set(record, "confirmed_by", payload.confirmed_by)
    }
  },
  deleteFormRecord(state, idForm) {
    state.forms.results = state.forms.results.filter(rec => rec.id != idForm)
  },
  setFormPagination(state, payload) {
    state.formPagination = payload
  },
  setDefaultFormPagination(state) {
    state.formPagination = state.pagination
  },
  updateFieldValue(state, {
    idForm,
    schemaField,
    value
  }) {
    state.forms.results
      .find(form => form.id == idForm).results
      .find(record => record.order == schemaField.order)
      .value = value
  },
  updateStateForm(state, payload) {
    let form = state.forms.results
      .find(form => form.id == payload.form_id)
    Vue.set(form, "state", payload.state)
  },
  setRelatedSchemas(state,payload){
    state.relatedSchemas = payload
  },
  setAgencies(state,payload){
    state.agencies = payload
  },
  setRelatedGroupTypes(state,payload){
    state.relatedGroupTypes = payload
  },
  setRelatedGroup(state,payload){
    state.relatedGroup = payload
  },
  addRelatedValuesType(state,payload){
      state.relatedValuesType.push(payload)
  },
  setFormPayload(state, payload){
    state.formPayload = payload
  },
  addRelatedValues(state, payload){
    state.relatedValues.push(payload)
  }
}
